import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { CartItemType } from '@base/cart/interface';
import Image from '@base/lib/ThemeImage';
// import ProductCouponTag from '@base/snippets/ProductCouponTag';
import ListProductSoldOut from '@base/snippets/ListProduct/ListProductSoldOut';
import OrderProductTag from '@base/snippets/OrderProductTag';
import { ICartGroup } from 'mod/cart/interface';
import { useTrans } from 'base/utils/i18n';

type CartItemImageProps = {
    className?: string;
    item: CartItemType;
    width: number;
    batchActive?: boolean;
    group: ICartGroup;
};

const CartItemImage: React.FC<CartItemImageProps> = props => {
    const { className, item, width, batchActive = false, group } = props;
    const href = batchActive ? void 0 : item.productUrl;
    const { t } = useTrans();

    return (
        <div className={cn(styles['img-wrap'], className)}>
            <Image
                className="picture"
                href={href}
                src={item.productVariantPic}
                width={width}
            />

            {!group.forceBatchOperate && <OrderProductTag product={item}/>}

            {/* 商品coupon优惠 */}
            {/*<ProductCouponTag className="tag" isShowPrice={false} discountPriceNumDisplay={item?.discountPriceNumDisplay}/>*/}

            {item.stockNum === 0 && (
                <ListProductSoldOut
                    link={href}
                    text={t('web_product_sold_out')}
                    className="sold-out"
                    canJump={!batchActive}
                />
            )}
        </div>
    )
};

export default CartItemImage;